(function () {
    'use strict';

    angular.module("imApp").factory("prodGrpService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 917,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 918,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 919,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
